var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "itemsModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "ModalLabel"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            _vm._l(_vm.items, function(item, index) {
              return _c("div", { key: index, staticClass: "media" }, [
                _c("div", { staticClass: "media-left" }, [
                  _c("a", { attrs: { href: item.vue.url, target: "_blank" } }, [
                    _c("img", {
                      staticClass: "media-object",
                      staticStyle: { width: "64px", height: "64px" },
                      attrs: { src: item.vue.image_url, alt: "" }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "media-body" }, [
                  _c("h6", { staticClass: "media-heading" }, [
                    _c(
                      "a",
                      { attrs: { href: item.vue.url, target: "_blank" } },
                      [_vm._v(_vm._s(item.vue.name))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.sku_name))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.quantity || 1) + " шт.")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "price" }, [
                    _vm._v(_vm._s(item.vue.wa_currency))
                  ])
                ])
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-success",
                attrs: {
                  href:
                    "?plugin=ordercall&module=shop&action=order&order_id=" +
                    _vm.orderId,
                  type: "button"
                }
              },
              [_vm._v("Создать новый заказ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-link",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [_vm._v("Закрыть")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title", attrs: { id: "ModalLabel" } }, [
        _vm._v("Товары в корзине")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bef4ae1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bef4ae1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/dialogs/ItemsModal.vue
// module id = 205
// module chunks = 1